import { render, staticRenderFns } from "./setSign.vue?vue&type=template&id=3b983959&scoped=true&"
import script from "./setSign.vue?vue&type=script&lang=js&"
export * from "./setSign.vue?vue&type=script&lang=js&"
import style0 from "./setSign.vue?vue&type=style&index=0&id=3b983959&lang=scss&scoped=true&"
import style1 from "./setSign.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b983959",
  null
  
)

export default component.exports